let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aiOLS")).then(() => parcelRequire('g2xHn'));